import React, { useId } from 'react';
import { Button } from '@els/els-react--button';

// FR-1.1: onboarding state — one card, two full-width stacked buttons. No request is issued
// automatically on mount/hover/focus; only an explicit click triggers generation.
// FR-1.2: "Summarise selected results" validates 1-20 selected results before sending scope=SELECTED.
function AssistantOnboarding({ selectedItems = [], onSummarizeTop, onSummarizeSelected, selectionError }) {
  const selectionErrorId = useId();

  return (
    <div className="ai-search-summary__onboarding" data-testid="summary-onboarding">
      <div className="ai-search-summary__onboarding-card">
        <h3 className="ai-search-summary__onboarding-title">Get the key insights faster</h3>
        <div className="ai-search-summary__onboarding-description">
          <p>
            See common patterns and outliers across the 20 highest-ranked results relevant to your query, with links back to their sources.
          </p>
        </div>
      </div>
      <div className="ai-search-summary__onboarding-actions">
        <Button
          type="primary"
          className="ai-search-summary__onboarding-action"
          data-e2e="summarize-results-button"
          onClick={onSummarizeTop}>
          Summarise results
        </Button>
        <Button
          type={selectionError ? 'warn' : 'secondary'}
          className="ai-search-summary__onboarding-action"
          data-e2e="summarize-selected-results-button"
          aria-describedby={selectionError ? selectionErrorId : undefined}
          onClick={() => onSummarizeSelected(selectedItems)}>
          Summarise selected results
        </Button>
      </div>
      <div
        id={selectionErrorId}
        role="alert"
        className={selectionError ? 'ai-search-summary__selection-error u-els-margin-top-1o2 u-els-color-n-error' : undefined}>
        {selectionError && (
          <>
            <span className="u-els-hide-visually">Error: </span>
            {selectionError}
          </>
        )}
      </div>
    </div>
  );
}

export default AssistantOnboarding;
